import { ESolarServiceProvider } from "../enums/solar-service-provider";

export const getServiceProviderName = (
  serviceProvider: ESolarServiceProvider,
): string => {
  switch (serviceProvider) {
    case ESolarServiceProvider.VRM:
      return "Victron VRM";
    case ESolarServiceProvider.GOODWE:
      return "GoodWe";
    case ESolarServiceProvider.GROWATT:
      return "Growatt";
    case ESolarServiceProvider.POWERHUB:
      return "Tesla Powerhub";
    case ESolarServiceProvider.SCOUT:
      return "Scout";
    default:
      return "Unknown";
  }
};

export const getServiceProviderUrl = (
  serviceProvider: ESolarServiceProvider,
): string | null => {
  switch (serviceProvider) {
    case ESolarServiceProvider.VRM:
      return "https://vrm.victronenergy.com/";
    case ESolarServiceProvider.GOODWE:
      return "https://www.semsportal.com/";
    case ESolarServiceProvider.GROWATT:
      return "https://oss.growatt.com/";
    case ESolarServiceProvider.POWERHUB:
      return "https://www.tesla.com/";
    default:
      return null;
  }
};

export const openServiceProviderPortal = (
  serviceProvider: ESolarServiceProvider,
): void => {
  const url = getServiceProviderUrl(serviceProvider);
  if (url) {
    window.open(url, "_blank", "noreferrer");
  }
};

export const getOpenInButtonText = (
  serviceProvider: ESolarServiceProvider,
): string => {
  return `Open in ${getServiceProviderName(serviceProvider)}`;
};
